import React from 'react';
import { useAppSelector } from '../store';
import { hasAnyAuthority } from './authorization';
import PermissionDeniedScreen from './PermissionDeniedScreen';

export default function RequireAuthorities({
  children,
  requiredAuthorities,
  backTo = '/configuracion',
  backLabel = 'Ir a configuración',
}: {
  children: React.ReactNode;
  requiredAuthorities: string[];
  backTo?: string;
  backLabel?: string;
}) {
  const account = useAppSelector(s => s.authentication.account);
  if (!hasAnyAuthority(account?.authorities, requiredAuthorities)) {
    return (
      <PermissionDeniedScreen
        requiredAuthorities={requiredAuthorities}
        backTo={backTo}
        backLabel={backLabel}
      />
    );
  }
  return <>{children}</>;
}
